// src/version.ts
var PKG_NAME = "@liveblocks/react";
var PKG_VERSION = "2.11.1";
var PKG_FORMAT = "esm";

// src/ClientSideSuspense.tsx
import * as React from "react";
function ClientSideSuspense(props) {
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  return /* @__PURE__ */ React.createElement(React.Suspense, { fallback: props.fallback }, mounted ? typeof props.children === "function" ? props.children() : props.children : props.fallback);
}

export {
  PKG_NAME,
  PKG_VERSION,
  PKG_FORMAT,
  ClientSideSuspense
};
//# sourceMappingURL=chunk-JF4QXLDE.mjs.map